import { render } from "./TheNewsBar.vue?vue&type=template&id=962fa7b8&scoped=true"
import script from "./TheNewsBar.vue?vue&type=script&lang=js"
export * from "./TheNewsBar.vue?vue&type=script&lang=js"

import "./TheNewsBar.vue?vue&type=style&index=0&id=962fa7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962fa7b8"]])

export default __exports__